import { Node } from "@tiptap/core"
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react"
import { IconTrashOutline18 as TrashIcon } from "nucleo-ui-outline-18"

import { IconButton, Tooltip } from "@productlane/ui"

import type { NodeViewProps } from "@tiptap/react"
import { EmailHtml } from "@/components/email-html"

export const EMAIL_SIGNATURE_ATTR = "data-email-signature"

// A signature built in another tool (tables, logos, inline styles) cannot survive
// the editor's schema, so it is kept as one untouched block of HTML.
export const isRichSignatureHtml = (html: string) =>
	/<(table|img)\b/i.test(html)

function EmailSignatureView({ node, deleteNode, editor }: NodeViewProps) {
	return (
		<NodeViewWrapper
			contentEditable={false}
			className="group relative my-1"
			data-drag-handle=""
		>
			<EmailHtml html={node.attrs.html as string} />
			{editor.isEditable && (
				<div className="absolute right-0 top-0 opacity-0 group-hover:opacity-100">
					<Tooltip label="Remove">
						<IconButton
							variant="ghost"
							size="sm"
							Icon={TrashIcon}
							aria-label="Remove"
							onClick={deleteNode}
						/>
					</Tooltip>
				</div>
			)}
		</NodeViewWrapper>
	)
}

export const EmailSignature = Node.create({
	name: "emailSignature",
	group: "block",
	atom: true,
	selectable: true,

	addAttributes() {
		return {
			html: {
				default: "",
				parseHTML: (element) => element.innerHTML,
				renderHTML: () => ({}),
			},
		}
	},

	parseHTML() {
		return [{ tag: `div[${EMAIL_SIGNATURE_ATTR}]` }]
	},

	renderHTML({ node }) {
		const dom = document.createElement("div")
		dom.setAttribute(EMAIL_SIGNATURE_ATTR, "true")
		dom.innerHTML = node.attrs.html as string
		return dom
	},

	addNodeView() {
		return ReactNodeViewRenderer(EmailSignatureView)
	},
})
